import { ApolloError, FetchResult, useMutation } from '@apollo/client';
import { useCallback, useMemo } from 'react';
import { Mutations } from '@shared/api';
import { API } from '@shared/types/api';

interface UpdateWorkflowEntity {
  updateWorkflowEntity: (
    id: string,
    fields: any,
    viewTemplateId?: string | null,
  ) => Promise<FetchResult<API.UpdateWorkflowEntityMutation>>;
  loading: boolean;
  error: ApolloError | undefined;
}

export function useUpdateWorkflowEntity(): UpdateWorkflowEntity {
  const [update, { loading, error }] = useMutation<
    API.UpdateWorkflowEntityMutation,
    API.UpdateWorkflowEntityMutationVariables
  >(Mutations.entity.updateWorkflowEntity);

  const updateWorkflowEntity = useCallback(
    (id: string, fields: any, viewTemplateId?: string | null) => {
      return update({
        variables: {
          input: {
            id,
            fields,
            viewTemplateId,
          },
        },
      });
    },
    [update],
  );

  return useMemo(() => {
    return {
      updateWorkflowEntity,
      loading,
      error,
    };
  }, [updateWorkflowEntity, loading, error]);
}
